import apiService from "modules/api/apiService";
import { LOGIN_URL, LOGOUT_URL } from "modules/api/endpoint";
import { API_STATUS } from "modules/api/type";

import { LoginDonePayload } from "./authActions";

export const loginByToken = async (token: string): Promise<LoginDonePayload> => {
  const authResult = await apiService.post(`${LOGIN_URL}/${token}`, {});
  if (authResult.status === API_STATUS.success) {
    return { authUser: authResult.data.payload, error: null };
  }

  return { error: authResult.data };
};

export const logout = async () => {
  try {
    const result = await apiService.post(LOGOUT_URL, {});
  } catch (e) {
    console.log("error from logout ===>", e.message);
  }
};
